<template>
    <div>
        <v-card
            outlined
            class="pa-4 ma-0"
        >
        <div class="text-h6 mt-3 mb-4">Pesquisa de Proposta</div>

        <v-form ref="form" class="p-2">
            <v-row dense> 
                <v-col cols="12" xs="2" sm="2" md="2" lg="2" xl="2">
                    <v-tooltip top max-width="650px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="params.multiple_codigo"
                                outlined
                                dense
                                label="Codigos"
                                append-icon="mdi-help-circle-outline"
                                v-on="on"
                                :class="$css_field"
                                clearable
                                @keydown.enter="submit"
                            >
                                <template v-slot:label>
                                    <span :class="$css_field">Código Proposta</span>
                                </template>
                            </v-text-field>
                        </template>
                        <span>
                            Para pesquisar mais de um codigo basta separar por virgula
                        </span>
                    </v-tooltip>
                </v-col>
                <v-col cols="12" xs="2" sm="2" md="2" lg="2" xl="2">
                    <v-tooltip top max-width="650px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="params.multiple_codigo_imovel"
                                outlined
                                dense
                                label="Codigo Imóvel"
                                append-icon="mdi-help-circle-outline"
                                v-on="on"
                                :class="$css_field"
                                clearable
                                @keydown.enter="submit"
                            >
                                <template v-slot:label>
                                    <span :class="$css_field">Código Imóvel</span>
                                </template>
                            </v-text-field>
                        </template>
                        <span>
                            Para pesquisar mais de um codigo de imóvel basta separar por virgula
                        </span>
                    </v-tooltip>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-select
                        v-model="params.multiple_status"
                        :items="items.status"
                        outlined
                        multiple
                        dense
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Status</span>
                        </template>

                        <template v-slot:selection="{ item, index }">
                            <div class="mr-1" v-if="index === 0">
                                <span :class="$css_field">{{ item }}</span>
                            </div>
                            <span
                                v-if="index === 1"
                                class="grey--text text-caption"
                            >
                                (+{{ params.multiple_status.length - 1 }} opções)
                            </span>
                        </template>   

                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-select
                        v-model="params.multiple_setor"
                        :items="items.setores"
                        outlined
                        dense
                        :class="$css_field"
                        multiple
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Setores</span>
                        </template>

                        <template v-slot:selection="{ item, index }">
                            <div class="mr-1" v-if="index === 0">
                                <span :class="$css_field">{{ item }}</span>
                            </div>
                            <span
                                v-if="index === 1"
                                class="grey--text text-caption"
                            >
                                (+{{ params.multiple_setor.length - 1 }} opções)
                            </span>
                        </template>  

                    </v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <v-select
                        v-model="params.tipo_imovel"
                        :items="items.tipos_imovel"
                        item-text="tipo"
                        item-value="tipo"
                        outlined
                        dense
                        clearable
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Tipo Imovel</span>
                        </template>
                    </v-select>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="params.endereco"
                        outlined
                        dense
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Endereço</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="params.numero"
                        label="Número"
                        type="number"
                        outlined
                        dense
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Número</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        v-model="params.apartamento"
                        type="number"
                        outlined
                        dense
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Apto</span>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col  cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="params.proprietario"
                        outlined
                        dense
                        required
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Proprietário</span>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col  cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field
                        v-model="params.resident"
                        outlined
                        dense
                        required
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Proponent</span>
                        </template>
                    </v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-currency-field
                        v-model="params.valor_proposta_from"
                        outlined
                        dense
                        :class="$css_field"
                        prefix="R$"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Vl proposta de</span>
                        </template>
                    </v-currency-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-currency-field
                        v-model="params.valor_proposta_to"
                        outlined
                        dense
                        :class="$css_field"
                        prefix="R$"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Vl proposta até</span>
                        </template>
                    </v-currency-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-menu
                        v-model="calendar.data_cadastro_from"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                dense
                                outlined
                                v-model="params.data_cadastro_from"
                                append-icon="mdi-calendar-range"
                                readonly
                                clearable
                                v-on="on"
                            >
                                <template v-slot:label>
                                    <span :class="$css_field">Dt cadastro de</span>
                                </template>  
                            </v-text-field>
                        </template>

                        <v-date-picker locale="pt-br" v-model="data_cadastro_from" @input="calendar.data_cadastro_from = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-menu
                        v-model="calendar.data_cadastro_to"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                dense
                                outlined
                                v-model="params.data_cadastro_to"
                                append-icon="mdi-calendar-range"
                                readonly
                                v-on="on"
                                clearable
                            >
                                <template v-slot:label>
                                    <span :class="$css_field">Dt cadastro até</span>
                                </template>    
                            </v-text-field>
                        </template>

                        <v-date-picker locale="pt-br" v-model="data_cadastro_to" @input="calendar.data_cadastro_to = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-autocomplete
                        v-model="params.colaborator"
                        :items="items.users"
                        outlined
                        dense
                        item-text="name"
                        item-value="id"
                        :class="$css_field"
                        clearable
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Colaborador</span>
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>

            <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                    <v-btn
                        dark
                        color="grey darken-1"
                        @click.prevent="clear" 
                        :class="$css_button + ' ma-2'"
                        :block="$vuetify.breakpoint.smAndDown"
                    >
                        Limpar
                    </v-btn>
                    <v-btn
                        dark
                        color="primary"
                        @click.prevent="submit"
                        :class="$css_button + ' ma-2'"
                        :block="$vuetify.breakpoint.smAndDown"
                    >
                        Pesquisar
                    </v-btn>
                </v-col>  
            </v-row>
        </v-form>    
        </v-card>
    </div>
</template>

<script>
import { TIPO_IMOVEL_PROPERTY_ITEMS } from '@/components/properties2/config_properties/config_properties.js' 
import { STATUS_ITEMS } from './config_proposals/config_proposals.js'

import eventBus from '@/event-bus'

export default {
    created(){
        this.loadUsers()
    },

    mounted() {
        window.scrollTo(0, 0);
        //eventBus.$emit('setDrawer', true); // nao vamos usar no momento
        const filters = { ...this.$route.query}; // Cópia direta dos parâmetros
        this.params = filters     
    },    

    computed: {
        me () {
          return this.$store.state.auth.me
        },
    },

    watch: {
        data_cadastro_from () {
            this.params.data_cadastro_from = this.formatDate(this.data_cadastro_from)
        },

        data_cadastro_to () {
            this.params.data_cadastro_to = this.formatDate(this.data_cadastro_to)
        },
    }, 

    data() {
        return {
            data_cadastro_from: '',
            data_cadastro_to: '',
        
            calendar: {
                data_cadastro_from: false,
                data_cadastro_to: false,
            },

            items_params: {
                paginate: 'false'
            },

            params: {
                multiple_codigo: [],
                multiple_codigo_imovel: [],
                multiple_status: [],
                multiple_setor: [],
                tipo_imovel: '',
                endereco: '',
                numero: '',
                apartamento: '',
                proprietario: '',
                resident: '',
                valor_proposta_from: '',
                valor_proposta_to: '',
                data_cadastro_from: '',
                data_cadastro_to: '',
                colaborator: ''
            },
            
            items: {
                status: STATUS_ITEMS,
                setores: ['Venda','Locação'],
                tipos_imovel: TIPO_IMOVEL_PROPERTY_ITEMS,
                users: [],   
            },
        }
    },

    methods: {
        loadUsers(){
            const user_params = {}
            user_params.paginate = 'false'
            user_params.all = 'true'
            this.$store.dispatch('loadPromisseUsers', user_params)
                        .then(response => {
                            this.items.users = response.data   
                        })
                        .catch(error => {
                            console.log(error)
                        })
        },

        clear() {
            this.$refs.form.reset()
        },

        submit(){
            const cleanedParams = Object.keys(this.params).filter(key => {
                const value = this.params[key];
                
                // Caso 1: Valores não-array (mantém a lógica original)
                if (!Array.isArray(value)) {
                    return value !== null && value !== "" && value !== undefined;
                }
                
                // Caso 2: Para arrays, remove se estiver vazio
                return value.length > 0;
            })
            .reduce((obj, key) => {
                obj[key] = this.params[key];
                return obj;
            }, {});


            this.$router.push({
                name: 'admin.proposals.search',
                query: cleanedParams
            });
        },
        
    }
}
</script>